@let current = media();
@let manual = manualTwicpics();
@let id = customId() || '';

@if (!current?.urlTwicPic || twicError()) {

  <img #element
    [id]="id"
    [src]="fallbackUrl()"
    [alt]="altText()"
    [attr.width]="imgWidth()"
    [attr.height]="imgHeight()"
    [attr.aria-hidden]="ariaHidden()"
    [attr.role]="ariaRole()"
    [attr.data-type]="dataType()"
    (load)="imageLoaded()"
  />

} @else if (twicPicsAutoSize()) {

  <img #element
    [id]="id"
    [src]="twicpicsUrl()"
    [alt]="altText()"
    class="twic"
    data-twic-step="1"
    [attr.width]="imgWidth()"
    [attr.height]="imgHeight()"
    [attr.aria-hidden]="ariaHidden()"
    [attr.role]="ariaRole()"
    [attr.data-type]="dataType()"
    [attr.data-twic-src]="current?.urlTwicPic"
    [attr.data-twic-src-transform]="twicpicsTransform()"
    (error)="fallbackToMedia()"
    (load)="imageLoaded()"
  />

} @else if (manual) {

  @let transform =  manual.url + manual.transform;
  @let url = manual.url;

  <picture>
    <source media="(min-width: 1600px)" [srcset]="
      transform + '2000 2000w,' +
      transform + '1800 1800w,' +
      transform + '1600 1600w'
    ">
    <source media="(min-width: 1280px)" [srcset]="
      transform + '1600 1600w,' +
      transform + '1450 1450w,' +
      transform + '1280 1280w'
    ">
    <source media="(min-width: 768px)" [srcset]="
      transform + '1280 1280w,' +
      transform + '1000 1000w,' +
      transform + '850 850w,' +
      transform + '768 768w'
    ">
    <source media="(max-width: 767px)" [srcset]="
      transform + '767 767w,' +
      transform + '500 500w,' +
      transform + '320 320w'
    ">
    <img #element
      [id]="id"
      [src]="url"
      [alt]="altText()"
      fetchpriority="high"
      loading="eager"
      [attr.width]="imgWidth()"
      [attr.height]="imgHeight()"
      [attr.aria-hidden]="ariaHidden()"
      [attr.role]="ariaRole()"
      [attr.data-type]="dataType()"
      [attr.data-twic-src]="current?.urlTwicPic"
      [attr.data-twic-src-transform]="twicpicsTransform()"
      (error)="fallbackToMedia()"
      (load)="imageLoaded()"
    />
  </picture>

}
